import { NativeModules } from 'react-native';
import { INDEX_UNKNOWN } from './index-def';
const resultUnknown = {
    index: INDEX_UNKNOWN
};
let evaluatedIndex;
export async function evaluate() {
    if (evaluatedIndex) {
        return evaluatedIndex;
    }
    if (!NativeModules.QDDeviceUtilSupportModule ||
        !NativeModules.QDDeviceUtilSupportModule.evaluatePerformance) {
        return resultUnknown;
    }
    try {
        evaluatedIndex = await NativeModules.QDDeviceUtilSupportModule.evaluatePerformance();
        return evaluatedIndex;
    }
    catch (err) {
        return resultUnknown;
    }
}
